<template>
	<div style="display: flex; flex-direction: row; justify-content: space-between; align-items: center; gap: 10px">
		<div class="row-container">
			<IconWithCount
				icon="fas fa-thumbs-up approved-lender-icon"
				:tooltipInfo="approvedApplications"
				tooltipdirection="right"
				maxtooltipCount="3"
			/>
			<span :class="{ 'number-count': true, 'bolded': approvedApplications > 0 }">{{ approvedApplications ? `${approvedApplications}` : '-' }}</span>
		</div>
		<div class="row-container">
			<IconWithCount
				icon="fas fa-exchange-alt conditional-lender-icon"
				:tooltipInfo="conditionalApplications"
				tooltipdirection="right"
				maxtooltipCount="3"
			/>
			<span :class="{ 'number-count': true, 'bolded': conditionalApplications > 0 }">{{ conditionalApplications ? `${conditionalApplications}` : '-' }}</span>
		</div>
		<div class="row-container">
			<IconWithCount
				icon="fas fa-thumbs-down denied-lender-icon"
				:tooltipInfo="deniedApplications"
				tooltipdirection="right"
				maxtooltipCount="3"
			/>
			<span :class="{ 'number-count': true, 'bolded': deniedApplications > 0 }">{{ deniedApplications ? `${deniedApplications}` : '-' }}</span>
		</div>
	</div>
</template>

<script setup lang="ts">
	import IconWithCount from '@/components/IconWithCount.vue';

	interface Props {
		approvedApplications: number;
		conditionalApplications: number;
		deniedApplications: number;
	}

	defineProps<Props>();
</script>

<style scoped>
	.row-container {
		display: flex;
		font-size: 1em;
		align-items: center;
		width: 100%;
		border: 1px solid var(--border-color);
		padding: 5px;
		border-radius: 5px;
	}

	.row-container span {
		font-size: 0.75em;
		color: var(--main-color);
		margin: auto;
		text-align: center;
	}

	.row-container span.bolded {
		font-weight: 600;
	}

	.row-container span.number-count {
		min-width: 19px;
		padding: 0 5px 0 0px;
	}
</style>
